document.addEventListener("DOMContentLoaded", function() {
    console.log("Test Custom JS");
    var sideBarFilter = document.querySelector('.shopify-section--main-collection');
    var inputsArr = [];
    var inputsMobArr = [];

    if(typeof sideBarFilter != 'undefined' && sideBarFilter != null) {
        setInputsListeners();

        // Create a new observer instance
        const observer = new MutationObserver((mutationsList, observer) => {
            // Callback function to execute when mutations are observed
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    console.log('A child node has been added or removed.');
                    setInputsListeners();
                }
            }
        });

        // Configuration of the observer
        const config = { 
            attributes: true,
            childList: true,
            subtree: true 
        };

        // Start observing the target node
        observer.observe(sideBarFilter, config);

        function setInputsListeners() {
            console.log("Setting listener");
            //Desktop setup
            var setInStockDesktop = document.getElementById('facets-facets-sidebar-form-filter.v.availability');
            
            var sidebarFilter = document.getElementById('facets-sidebar-form');
            
            var inputs = sidebarFilter.querySelectorAll('input');
            
            inputs.forEach(function(el, index) {
                if(el.id != 'facets-facets-sidebar-form-filter.v.availability') {
                    inputsArr[index] = el;
                    inputsArr[index].addEventListener('change', function(e) {
                        console.dir(e);
                        if(e.target.checked && !setInStockDesktop.checked) {
                            setInStockDesktop.click();
                        }
                    });
                }
            });

            //Mobile setup
            var setInStockMobile = document.getElementById('facets-facets-drawer-form-filter.v.availability');
            var sidebarFilterMobile = document.getElementById('facets-drawer-form');
            var inputsMobile = sidebarFilterMobile.querySelectorAll('input');

            inputsMobile.forEach(function(el, index) {
                if(el.id != 'facets-facets-drawer-form-filter.v.availability') {
                    inputsMobArr[index] = el;
                    inputsMobArr[index].addEventListener('change', function(e) {
                        if(e.target.checked && !setInStockMobile.checked) {
                            setInStockMobile.click();
                        }
                    });
                }
            });

        }
    }

    // setTimeout(function() {
    //     var setInStock = document.getElementById('facets-facets-sidebar-form-filter.v.availability');

    //     setInStock.click();
    // }, 1000);
});

// Size Chart
function renderSizeChart(csvData) {
  if (!csvData) return '';
  
  const lines = csvData.trim().split('\n');
  
  // Handle single line size list (like "S, M, L, XL, XXL")
  if (lines.length === 1) {
    const sizes = lines[0].split(',').map(s => s.trim());
    let html = '<div class="size-list"><h4>Available Sizes:</h4><div class="size-badges">';
    sizes.forEach(size => {
      html += `<span class="size-badge">${size}</span>`;
    });
    html += '</div></div>';
    return html;
  }
  
  // Handle CSV table format
  const headers = lines[0].split(',');
  const rows = lines.slice(1).map(line => line.split(','));
  
  let html = '<table class="size-chart-table"><thead><tr>';
  headers.forEach(header => {
    html += `<th>${header.trim()}</th>`;
  });
  html += '</tr></thead><tbody>';
  
  rows.forEach(row => {
    html += '<tr>';
    row.forEach(cell => {
      html += `<td>${cell.trim()}</td>`;
    });
    html += '</tr>';
  });
  html += '</tbody></table>';
  
  return html;
}

// Initialize size charts on page load
document.addEventListener('DOMContentLoaded', function() {
  const sizeChartData = document.querySelector('[data-size-chart]')?.textContent;
  const container = document.querySelector('.size-chart-container');
  
  if (container && sizeChartData) {
    container.innerHTML = renderSizeChart(sizeChartData.trim());
  }
});